import {
    DELETE_PRODUCT_IMAGE,
    DELETE_PRODUCT_IMAGE_FAILURE,
    DELETE_PRODUCT_IMAGE_SUCCESS,
} from 'store/actions/types';

export const deleteProductImage = (payload) => {
    return {
        type: DELETE_PRODUCT_IMAGE,
        payload: payload,
    };
};

export const deleteProductImageFailure = (error) => {
    return {
        type: DELETE_PRODUCT_IMAGE_FAILURE,
        error: error,
    };
};

export const deleteProductImageSuccess = (product_id, image_id) => {
    return {
        type: DELETE_PRODUCT_IMAGE_SUCCESS,
        imageId: image_id,
        productId: product_id,
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/products/images/deleteImage.js